import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

const cleanParams = params => Object.entries(params || {}).reduce((acc, [key, value]) => {
	if (value !== null && value !== undefined && value !== '') acc[key] = value
	return acc
}, {})

export const listCampaignBanners = (params = '') => Http.get(`/campaigns-banners${serialize(cleanParams(params))}`)
export const createCampaignBanner = params => Http.post('/campaigns-banners', params)
export const getCampaignBannerById = id => Http.get(`/campaigns-banners/${id}`)
export const updateCampaignBanner = params => Http.put(`/campaigns-banners/${params.id}`, params)
export const deleteCampaignBanner = id => Http.delete(`/campaigns-banners/${id}`)
export const approveCampaignBanner = id => Http.post(`/campaigns-banners/${id}/approve`)
export const rejectCampaignBanner = (id, reason) => Http.post(`/campaigns-banners/${id}/reject`, { reason })
export const renewCampaignBanners = ids => Http.post('/campaigns-banners/renew', { ids, days: 90 })
